import React from "react";
import ReactDOM from "react-dom/client";
import { initSentry } from "@/lib/sentry";
import "@/index.css";
import App from "@/App";

// Initialize Sentry BEFORE rendering so React errors are captured.
// No-op when REACT_APP_SENTRY_DSN is unset.
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
